import { render, staticRenderFns } from "./MarketingPlanModal.vue?vue&type=template&id=0876b9c2&scoped=true"
import script from "./MarketingPlanModal.vue?vue&type=script&lang=js"
export * from "./MarketingPlanModal.vue?vue&type=script&lang=js"
import style0 from "./MarketingPlanModal.vue?vue&type=style&index=0&id=0876b9c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0876b9c2",
  null
  
)

export default component.exports